/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  Condition,
  ErrorResponse,
  ScopeCreateRequest,
  ScopeOverviewResponseCollectionResponse,
  ScopeResolvedSkuCountResponseDataResponse,
  ScopeResolvedSkuResponseCollectionResponse,
  ScopeResponseDataResponse,
  ScopeSectionCreateRequest,
  ScopeSectionResponseDataResponse,
  ScopeSectionRuleReplaceRequest,
  ScopeSectionRuleTypeName,
  ScopeUpdateRequest,
  ScopeUsageResponseCollectionResponse,
  Sorting,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';
export class Scopes<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Scopes
   * @name ScopesList
   * @request GET:/Scopes
   * @response `200` `ScopeOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scopesList = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ScopeOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Scopes`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name CreateScope
   * @request POST:/Scopes
   * @response `200` `ScopeResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  createScope = (data: ScopeCreateRequest, params: RequestParams = {}) =>
    this.http.request<ScopeResponseDataResponse, ErrorResponse>({
      path: `/Scopes`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name GetScope
   * @request GET:/Scopes/{id}
   * @response `200` `ScopeResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getScope = (id: number, params: RequestParams = {}) =>
    this.http.request<ScopeResponseDataResponse, ErrorResponse>({
      path: `/Scopes/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name UpdateScope
   * @request PATCH:/Scopes/{id}
   * @response `204` `void` No Content
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  updateScope = (id: number, data: ScopeUpdateRequest, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Scopes/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name GetScopeUsages
   * @request GET:/Scopes/{id}/Usages
   * @response `200` `ScopeUsageResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getScopeUsages = (id: number, params: RequestParams = {}) =>
    this.http.request<ScopeUsageResponseCollectionResponse, ErrorResponse>({
      path: `/Scopes/${id}/Usages`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name GetScopeSkus
   * @request GET:/Scopes/{id}/Skus
   * @response `200` `ScopeResolvedSkuResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getScopeSkus = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ScopeResolvedSkuResponseCollectionResponse, ErrorResponse>({
      path: `/Scopes/${id}/Skus`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name GetScopeSkuCount
   * @request GET:/Scopes/{id}/Skus/Count
   * @response `200` `ScopeResolvedSkuCountResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getScopeSkuCount = (id: number, params: RequestParams = {}) =>
    this.http.request<ScopeResolvedSkuCountResponseDataResponse, ErrorResponse>({
      path: `/Scopes/${id}/Skus/Count`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name CreateScopeSection
   * @request POST:/Scopes/{scopeId}/Sections
   * @response `200` `ScopeSectionResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  createScopeSection = (
    scopeId: number,
    data: ScopeSectionCreateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ScopeSectionResponseDataResponse, ErrorResponse>({
      path: `/Scopes/${scopeId}/Sections`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name DeleteScopeSection
   * @request DELETE:/Scopes/{scopeId}/Sections/{scopeSectionId}
   * @response `204` `void` No Content
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteScopeSection = (scopeId: number, scopeSectionId: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Scopes/${scopeId}/Sections/${scopeSectionId}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name PutScopeSectionRule
   * @request PUT:/Scopes/{scopeId}/Sections/{scopeSectionId}/Rules/{ruleType}
   * @response `204` `void` No Content
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  putScopeSectionRule = (
    scopeId: number,
    scopeSectionId: number,
    ruleType: ScopeSectionRuleTypeName,
    data: ScopeSectionRuleReplaceRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Scopes/${scopeId}/Sections/${scopeSectionId}/Rules/${ruleType}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name DeleteScopeSectionRule
   * @request DELETE:/Scopes/{scopeId}/Sections/{scopeSectionId}/Rules/{ruleType}
   * @response `204` `void` No Content
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteScopeSectionRule = (
    scopeId: number,
    scopeSectionId: number,
    ruleType: ScopeSectionRuleTypeName,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Scopes/${scopeId}/Sections/${scopeSectionId}/Rules/${ruleType}`,
      method: 'DELETE',
      ...params,
    });
}
